import { render } from "./BlogFirstTimeDentist.vue?vue&type=template&id=1e49f5d4"
import script from "./BlogFirstTimeDentist.vue?vue&type=script&lang=js"
export * from "./BlogFirstTimeDentist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__